import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import Stack from '@mui/joy/Stack';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import Chip from '@mui/joy/Chip';
import Divider from '@mui/joy/Divider';

import ListicleWorkItem from 'components/ListicleWorkItem';

import { CollabProps } from 'stores/collab_store';
import useCollabs from 'hooks/useCollabs';
import useUserIdentity from 'hooks/useUserIdentity';
import getIcon from 'utils/getIcon';

const SupportMeCollabList = observer(() => {
    const [loading, setLoading] = useState(false);
    const { fetchCollabsByVariant, getCollabsByVariant } = useCollabs();
    const { currentIdentity } = useUserIdentity();
    const [collabs, setCollabs] = useState([] as CollabProps[]);

    useEffect( () => {
        if(!currentIdentity?.key) return;
        setLoading(true);
        fetchCollabsByVariant(currentIdentity.key, "support").then(() => {

            const c = getCollabsByVariant(currentIdentity.key, "support");
            console.log("fetchCollabsByVariant", currentIdentity.key, c);
            setCollabs(c);
        })
        .finally(() => setLoading(false));
    }, [currentIdentity?.key, fetchCollabsByVariant]);

    return (
        <Stack spacing={3}>
            { loading &&
            <Typography level="body-xs">
                Loading
            </Typography>
            }
            <Divider >
            <Typography level="title-lg"
                endDecorator={<Chip>{
                collabs.length
                }</Chip>}
            >
                Your Support Collabs
            </Typography>
            </Divider>

                <Stack spacing={1}>
                {collabs.map((item: CollabProps) => {
                    return <ListicleWorkItem
                        key={item.key}
                        item={item} />

                })}

                    { !loading && collabs.length === 0 &&
                        <Stack
                            alignItems="center">
                        <Typography
                        >
                            Your support items will show up here.
                        </Typography>
                        </Stack>
                    }
                </Stack>

        </Stack>
    );
});

const SupportMeContent = () => {
    const navigate = useNavigate();
    const SupportIcon = getIcon('ContactSupportOutlined');
    return (
        <Stack spacing={3}>

            <Stack spacing={2}>
                <Button
                    endDecorator={<SupportIcon />}
                    onClick={() => navigate("/support/create")}>
                    Contact Support (Ted)
                </Button>
            </Stack>


            <SupportMeCollabList />

        </Stack>
    );
}

export default SupportMeContent;
